import {v4 as uuidv4} from 'uuid';
import Configuration from '../domain/Configuration';
import {Response} from '../domain/Collection';
import HttpError, {asyncStackCapture} from "../errors/HttpError";

export const headerSymbol = Symbol('headers');

// Things from Api Link that this does not do atm
// TODO: In flight
// TODO: Capture component that makes the call
// TODO: Interceptors and re-routing on 403, 303, etc.

const initOptions = (args = {}) => {
  let opts = {
    credentials: 'include',
    headers: {
      'Content-type': 'application/json',
      'Accept': 'application/json', // eslint-disable-line quote-props
      'Accept-Charset': 'utf-8',
    },
    signal: args.signal,
  };

  if (args.cookie) {
    opts.headers.cookie = args.cookie;
  } else if (args.connection) {
    opts.headers.cookie = args.connection.getAuthToken();
  }
  return opts;
};

const fetchUrl = asyncStackCapture('Error fetching url', async function (url, opts, args = {}){
  const {
    returnAll = false,
  } = args;
  const requestId = uuidv4().slice(0,4);
  const start = new Date().valueOf();

  await Configuration.forEachRequestInterceptor(async (interceptor) => {
    const req = await interceptor({ url, opts }, { requestId });
    if (!req || !req.url || !req.opts) {
      throw new Error("Both url and opts must be returned from all request interceptor functions")
    }
    url = req.url;
    opts = req.opts;
  });
  let res;
  try {
    const networkAdapter = Configuration.getCurrentPlatformAdapter();
    res = await networkAdapter.request(url, opts);
  } catch (err) {
    if (typeof err === 'object' && err && err.name === 'AbortError') {
      Configuration.onAbort(err)
    } else {
      Configuration.onError(err, {isError: true});
    }
    throw err;
  }
  const notOK = !res.ok;

  let jsonRes = null;

  try {
    if(res.headers.get("content-type") && res.headers.get("content-type").includes("application/json")) {
      jsonRes = await res.json();

      // set headers
      jsonRes[headerSymbol] = res.headers;
    }
  } catch(err) {
    console.log('Unexpected error while parsing JSON: ', err);
  }
  const end = new Date().valueOf();
  await Configuration.forEachResponseInterceptor( async (interceptor) => {
    const result = await interceptor(res, { jsonResponseBody: jsonRes, requestId, opts: opts, elapsedMS: end - start });
    res = result
    if (result && result.overrideRes) {
      res = result.raw
      jsonRes = result.json
    }

    if (!res) {
      throw new Error("res must be returned from all response interceptor functions")
    }
  });
  if (notOK) {
    const httpError = new HttpError(res, jsonRes);
    Configuration.onError(httpError, { isNotOK: true });
    throw httpError;
  }

  if (returnAll) {
    return {
      raw: res,
      json: jsonRes,
    }
  }

  if (jsonRes) {
    return jsonRes;
  }

  return res;
});

const handleGet = (url, optionArgs, fetchArgs) => {
  const fetched = fetchUrl(url, {
    ...initOptions(optionArgs),
    method: 'GET',
  }, fetchArgs);

  return fetched;
};

export default {
  get: async (url, args = {}) => {
    const {
      metaOverrideSet,
      raw = false,
      ...restArgs
    } = args;

    const fetched = await handleGet(url, restArgs);

    if (raw) {
      return fetched;
    }

    return new Response({ data: fetched, metaOverrideSet });
  },
  Get: handleGet,
  Delete: (url, args) => fetchUrl(url, {
    ...initOptions(args),
    method: 'DELETE',
  }),
  Post: (url, data, optionArgs, fetchArgs) => {
    return fetchUrl(url, {
      ...initOptions(optionArgs),
      method: 'POST',
      body: JSON.stringify(data),
    }, fetchArgs);
  },
  Put: (url, data, args) => {
    return fetchUrl(url, {
      ...initOptions(args),
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },
};
